module.exports = __webpack_public_path__ + "assets/img/del_success.87a51b4c.png";